import actionTypes from './actionTypes';

const changeValue = (name, value) => ({
    type: actionTypes.CHANGE_VALUE,
    payload: {
        name: name,
        value: value
    }
});

const requestSave = () => ({
    type: actionTypes.REQUEST_SAVE
});

const saveResponse = (success, errors) => ({
    type: actionTypes.SAVE_RESPONSE,
    payload: {
        success: success,
        errors: errors,
        password: success ? {
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        } : {}
    }
});

const displayErrors = (errors) => ({
    type: actionTypes.DISPLAY_ERRORS,
    payload: {
        errors: errors
    }
});

export default {
    changeValue,
    requestSave,
    saveResponse,
    displayErrors
};